import { useRef as s } from "react";
import { VARIABLE_NODE_NAME as c } from "./index.es494.js";
import { VariableState as n } from "./index.es137.js";
var b = function b(u) {
  var e = s(null),
    t = function t() {
      e.current && (e.current.removeAttribute(n.hovered), e.current = null);
    };
  return {
    onMouseOver: function onMouseOver(o) {
      if (!u.current) return;
      var r = document.elementsFromPoint(o.clientX, o.clientY).findLast(function (i) {
        return i.nodeName === c;
      });
      r && r !== e.current && (t(), e.current = r, e.current.setAttribute(n.hovered, "")), r || t();
    },
    onMouseLeave: function onMouseLeave() {
      return t();
    }
  };
};
export { b as useVariableHover };